import Link from "next/link";

interface HeroProps {
    title: string;
    subtitle?: string;
    date?: string;
    showPublishedLabel?: boolean;
    categories?: {
        slug: {
            current: string;
        };
        _id: number;
        title: string;
    }[];
}

export default function Hero({
    title,
    date,
    subtitle,
    categories,
    showPublishedLabel,
}: HeroProps) {
    return (
        <section className={`blog-header ${!categories && "bg-gray-light"}`}>
            <div
                className={`pt-10 md:pt-20 pb-8 md:pb-14 max-w-screen-xl m-auto px-6 xl:px-0`}
            >
                <p className="font-light text-gray-dark">
                    {showPublishedLabel && <span>Objavljeno: </span>}
                    {showPublishedLabel && date}
                </p>

                <h1 className="text-4xl md:text-5xl !leading-tight pt-4 pb-6 font-semibold">
                    {title}
                </h1>
                <p className="text-xl md:text-2xl !leading-9 text-gray-dark">
                    {subtitle}
                </p>
                <div className="mt-4"></div>
                <Link href="/blog/kategorija/vijesti">
                    <a>
                        <span className="inline-block bg-blue-superlight text-indigo-500 text-sm px-4 py-1 rounded-full mr-4 mb-4">
                            Vijesti
                        </span>
                    </a>
                </Link>
                <Link href="/blog/kategorija/spotlights">
                    <a>
                        <span className="inline-block bg-violet-100 text-violet-800 text-sm px-4 py-1 rounded-full mr-4 mb-4">
                            Spotlights
                        </span>
                    </a>
                </Link>
                <Link href="/blog/kategorija/analize">
                    <a>
                        <span className="inline-block bg-orange-100 text-orange-800 text-sm px-4 py-1 rounded-full mr-4 mb-4">
                            Analize
                        </span>
                    </a>
                </Link>
                <Link href="/blog/kategorija/savjeti">
                    <a>
                        <span className="inline-block bg-green-100 text-green-800 text-sm px-4 py-1 rounded-full mr-4 mb-4">
                            Savjeti
                        </span>
                    </a>
                </Link>
                <Link href="/blog/kategorija/vodici">
                    <a>
                        <span className="inline-block bg-red-100 text-red text-sm px-4 py-1 rounded-full mr-4 mb-4">
                            Vodiči
                        </span>
                    </a>
                </Link>
            </div>
        </section>
    );
}
